import { useHistory, useLocation } from "react-router";
import { useCallback } from "react";
import { RoleStackItem } from "../redux-store/types/router";

export const useRoleStack = () => {
    const history = useHistory();
    const location = useLocation();

    const getCurrentStack = useCallback((): RoleStackItem[] => {
        return (location.state as { roleStack?: RoleStackItem[] })?.roleStack || [];
    }, [location.state]);

    const pushRole = useCallback((
        role: string,
        name: string,
        id: string,
        hierachyOptions: any,
        defaultOption: any,
        pathname = '/dashboard'
    ) => {
        const currentStack = getCurrentStack();
        const newStack: RoleStackItem[] = [...currentStack, { role, name, id, hierachyOptions, defaultOption }];

        history.push(pathname, { roleStack: newStack });
    }, [history, getCurrentStack]);

    const popRole = useCallback(() => {
        const currentStack = getCurrentStack();
        if (currentStack.length > 0) {
            const newStack = currentStack.slice(0, -1);
            history.replace('/dashboard', { roleStack: newStack });
        }
    }, [history, getCurrentStack]);

    const navigateWithStack = useCallback((
        pathname: string,
        state: any = {}
    ) => {
        const currentStack = getCurrentStack();
        history.push(pathname, {
            ...state,           // Your data
            roleStack: currentStack  // Preserve stack!
        });
    }, [history, getCurrentStack]);

    const getCurrentRoleName = useCallback((): RoleStackItem | undefined => {
        const stack = getCurrentStack();
        return stack[stack.length - 1];
    }, [getCurrentStack]);

    return {
        pushRole,
        popRole,
        navigateWithStack,
        getCurrentStack,
        getCurrentRoleName
    };
};
